/**
 * List of all sites
 */
export enum Site {
  ROISSY = '932440',
  WISSOUS = '912770',
  WISSOUS_COURRIER = '911270',
  MARTINIQUE = '972620',
  GUADELOUPE = '976220',
  GUYANE = '973260',
  MAYOTTE = '980180',
  ST_PIERRE_ET_MIQUELON = '975020',
  ST_BARTHELEMY = '976550',
  LE_BOURGET = '932930',
  REUNION = '974850',
  SAINT_MARTIN = '971810',
  DOUVRIN = '624200',
  MONTEREAU = '776050',
  CADUJAC = '330211',
  BAR_LE_DUC = '556140',
  ERSTEIN = '670960',
  LES_ARCS = '833680',
  LES_ALPES = '386870',
  LEMNYS = '752118',
  ROISSY_PIAC = '932490',
  DT_LOCALE = '932630',
  DSI_COLIS_APHELION = '929840',
}

/**
 * List of all roles
 */
export enum Role {
  // Roles for MAN
  SUP_SITE = 'SUP_SITE',
  AG_FINAL_MAN = 'AG_FINAL_MAN',
  // Roles for MAN and AUTO
  AG_PROD_VOLS = 'AG_PROD_VOLS',
  AG_CONSULT_VOLS = 'AG_CONSULT_VOLS',
  AG_FINAL_AUTO = 'AG_FINAL_AUTO',
  AG_FINAL_MAN_AUTO = 'AG_FINAL_MAN_AUTO',
  AG_FINAL_MAN_OPEX = 'AG_FINAL_MAN_OPEX',
  SUP_SITE_OPEX = 'SUP_SITE_OPEX',
  // Role for ADMIN
  ADMIN = 'ADMIN'
}

export const ExpeditionManuelProdRoleList = [Role.SUP_SITE, Role.SUP_SITE_OPEX, Role.AG_FINAL_MAN, Role.AG_FINAL_MAN_OPEX ]
export const ExpeditionAutoProdRoleList = [Role.AG_FINAL_AUTO, Role.AG_FINAL_MAN_AUTO]
export const ExpeditionAutoShowRoleList = [Role.SUP_SITE, Role.AG_FINAL_AUTO, Role.AG_FINAL_MAN_AUTO]
export const SupervisionProdRoleList = [Role.AG_PROD_VOLS]
export const SupervisionShowRoleList = [Role.SUP_SITE, Role.AG_PROD_VOLS, Role.AG_CONSULT_VOLS]
export const RechercheConsultationRoleList = [Role.SUP_SITE, Role.SUP_SITE_OPEX, Role.AG_FINAL_MAN, Role.AG_FINAL_AUTO, Role.AG_FINAL_MAN_AUTO, Role.AG_FINAL_MAN_OPEX]
export const SpidOpexRoles = [Role.AG_FINAL_MAN_OPEX, Role.SUP_SITE_OPEX]

/**
 * Sites using only EXP MAN
 */
export const SITES_EXP_MAN: string[] = [Site.WISSOUS, Site.WISSOUS_COURRIER, Site.MARTINIQUE, Site.GUADELOUPE, Site.GUYANE, Site.MAYOTTE,
  Site.ST_PIERRE_ET_MIQUELON, Site.ST_BARTHELEMY, Site.LE_BOURGET, Site.REUNION, Site.SAINT_MARTIN, Site.DOUVRIN, Site.MONTEREAU, Site.CADUJAC,
  Site.BAR_LE_DUC, Site.ERSTEIN, Site.LES_ARCS, Site.LES_ALPES];

/**
 * Sites using EXP MAN and AUTO (TCA)
 */
export const SITES_EXP_MAN_ET_AUTO: string[] = [Site.ROISSY, Site.LEMNYS, Site.ROISSY_PIAC, Site.DT_LOCALE, Site.DSI_COLIS_APHELION];
